import React from "react";
import { Container, PageHero } from "@/components/ui-blocks";
import Seo from "@/components/Seo";
import { COMPANY } from "@/data/mockData";
import { LegalBody, LegalSection } from "@/components/LegalBody";

export default function Terms() {
  return (
    <div data-testid="terms-page" className="bg-[#FDFBF7]">
      <Seo
        title="Terms & Conditions"
        description="The terms and conditions governing purchases from Ace Asia Productions, including orders, payment, delivery, and returns."
      />
      <PageHero
        testId="terms-hero"
        overline="Legal"
        title="Terms & Conditions"
        subtitle="The terms that govern your use of our website and your purchases."
      />

      <Container>
        <LegalBody updated="July 2026">
          <LegalSection title="1. About these terms">
            <p>
              These Terms &amp; Conditions govern your use of
              {" "}<strong>aceasia.com.sg</strong> and any purchase you make from
              {" "}{COMPANY.name} (UEN {COMPANY.uen}). By placing an order, you
              agree to these terms.
            </p>
          </LegalSection>

          <LegalSection title="2. Products & pricing">
            <ul>
              <li>All prices are listed in Singapore Dollars (SGD) and are inclusive of GST where applicable.</li>
              <li>We make every effort to display products and prices accurately, but errors may occur; we reserve the right to correct them.</li>
              <li>Product availability is not guaranteed and may change without notice. Certain items may be available only from their stated launch date.</li>
            </ul>
          </LegalSection>

          <LegalSection title="3. Orders">
            <p>
              When you place an order, you will receive an email confirming we
              have received it. This confirms receipt only; a contract is formed
              once payment is confirmed. We reserve the right to decline or
              cancel any order at our discretion (for example, if an item is out
              of stock or a pricing error has occurred), in which case any
              payment taken will be refunded.
            </p>
          </LegalSection>

          <LegalSection title="4. Payment">
            <p>
              Payments are processed securely by <strong>Stripe</strong>. We
              accept major credit and debit cards. Your order will be prepared
              once payment has been confirmed. We do not store your full card
              details.
            </p>
          </LegalSection>

          <LegalSection title="5. Delivery">
            <ul>
              <li>We deliver within Singapore and, where indicated, to selected South-east Asian destinations.</li>
              <li>Delivery timeframes are estimates and are not guaranteed.</li>
              <li>Risk in the goods passes to you upon delivery. You can follow your order status on our Track Order page.</li>
            </ul>
          </LegalSection>

          <LegalSection title="6. Returns & refunds">
            <p>
              If your item arrives damaged or defective, please contact us within
              7 days of delivery with your order number and photos, and we will
              arrange a replacement or refund. Due to the nature of our products,
              we are unable to accept returns of items that are not faulty unless
              required by law.
            </p>
          </LegalSection>

          <LegalSection title="7. Intellectual property">
            <p>
              All content on this website — including text, images, logos and
              publications — is owned by or licensed to {COMPANY.name} and is
              protected by applicable intellectual property laws. You may not
              reproduce or reuse it without our written permission.
            </p>
          </LegalSection>

          <LegalSection title="8. Limitation of liability">
            <p>
              To the fullest extent permitted by law, {COMPANY.name} shall not be
              liable for any indirect or consequential loss arising from your use
              of the website or products. Nothing in these terms excludes
              liability that cannot be excluded under Singapore law.
            </p>
          </LegalSection>

          <LegalSection title="9. Governing law">
            <p>
              These terms are governed by the laws of Singapore, and any disputes
              shall be subject to the exclusive jurisdiction of the Singapore
              courts.
            </p>
          </LegalSection>

          <LegalSection title="10. Contact us">
            <ul>
              <li>{COMPANY.name}</li>
              <li>Email: <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a></li>
              <li>Phone: <a href={`tel:${COMPANY.phone.replace(/\s+/g, "")}`}>{COMPANY.phone}</a></li>
            </ul>
          </LegalSection>
        </LegalBody>
      </Container>
    </div>
  );
}
